import * as React from "react";
import ReactDOM__default from "react-dom";
const useHeightAnimation = ({ currentTab, contentRef, contentInnerRef }) => {
  const [height, setHeight] = React.useState("auto");
  const contentHeightRef = React.useRef(0);
  const isAnimatingRef = React.useRef(false);
  React.useEffect(() => {
    const element = contentInnerRef.current;
    if (!element) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        if (isAnimatingRef.current) {
          setHeight(element.offsetHeight);
          isAnimatingRef.current = false;
        }
        contentHeightRef.current = element.offsetHeight;
      });
    });
    resizeObserver.observe(element);
    return () => resizeObserver.disconnect();
  }, [contentInnerRef]);
  React.useLayoutEffect(() => {
    const element = contentInnerRef.current;
    if (element && contentHeightRef.current) {
      requestAnimationFrame(() => {
        ReactDOM__default.flushSync(() => {
          isAnimatingRef.current = true;
          setHeight(contentHeightRef.current);
        });
      });
    }
  }, [currentTab, contentInnerRef]);
  const handleTransitionEnd = React.useCallback(
    (event) => {
      if (event.target === contentRef.current && event.propertyName === "height") {
        setHeight("auto");
      }
    },
    [contentRef]
  );
  return {
    handleTransitionEnd,
    height
  };
};
export {
  useHeightAnimation
};
